export const DEFAULT_ARRIVAL = '08:00 am';
export const DEFAULT_DEPARTURE = '05:00 pm';
